import { render, staticRenderFns } from "./LabourReport.vue?vue&type=template&id=59618a4b&scoped=true"
import script from "./LabourReport.vue?vue&type=script&lang=js"
export * from "./LabourReport.vue?vue&type=script&lang=js"
import style0 from "./LabourReport.vue?vue&type=style&index=0&id=59618a4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59618a4b",
  null
  
)

export default component.exports